import {$body} from "../../scripts/globals";

const c_name = 'cookie_approve_2022';
let i, x, y, ARRcookies = document.cookie.split(";");
let setCookie = false;

for (i = 0; i < ARRcookies.length; i++) {
    x = ARRcookies[i].substr(0, ARRcookies[i].indexOf("="));
    y = ARRcookies[i].substr(ARRcookies[i].indexOf("=") + 1);
    x = x.replace(/^\s+|\s+$/g, "");


    if (x == c_name) {
        setCookie = true;
        const consents = y.split(',');
        gtag('consent', 'update', {
            'ad_storage' : consents.includes('ad_storage') ? 'granted' :  'denied',
            'ad_user_data' : consents.includes('ad_storage') ? 'granted' :  'denied',
            'ad_personalization' : consents.includes('ad_storage') ? 'granted' :  'denied',
            'analytics_storage' : consents.includes('analytics_storage') ? 'granted' :  'denied',
            //'functionality_storage' : consents.includes('functionality_storage') ? 'granted' :  'denied',
        });

    }
}
if(!setCookie){
    gtag('consent', 'default', {
        'ad_storage' : 'denied',
        'ad_user_data' : 'denied',
        'ad_personalization' : 'denied',
        'analytics_storage' :'denied',
        //'functionality_storage' :  'denied',
    });
    gtag('event', 'default_consent');
} else {
    gtag('event', 'cookie_consent_update');
}

const CookieApprove = {
    container: null,
    containerSettings: null,

    Start: function () {
        if (!setCookie) {
            CookieApprove.createAndShowContainer();
        }
        $(".js-cookie-settings").on("click", function (e) {
            e.preventDefault();
            CookieApprove.createAndShowContainer();
        });
    },
    Approve: function () {
        CookieApprove.setCookie("ad_storage,analytics_storage,ad_user_data,ad_personalization"/*,functionality_storage*/);
        CookieApprove.container.slideUp("slow", function () {
            CookieApprove.container.remove();
            CookieApprove.containerSettings.remove();
        });
        gtag('consent', 'update', {
            'ad_storage' : 'granted',
            'ad_user_data' : 'granted',
            'ad_personalization' : 'granted',
            'analytics_storage' : 'granted',
            //'functionality_storage' : consents.includes('functionality_storage') ? 'granted' :  'denied',
        });
        gtag('event', 'cookie_consent_update');
    },
    checkSettings: function () {
        let i, x, y, ARRcookies = document.cookie.split(";");
        for (i = 0; i < ARRcookies.length; i++) {
            x = ARRcookies[i].substr(0, ARRcookies[i].indexOf("="));
            y = ARRcookies[i].substr(ARRcookies[i].indexOf("=") + 1);
            x = x.replace(/^\s+|\s+$/g, "");

            if (x == c_name) {
                let consents = y.split(',');
                if (consents.includes('ad_storage')) {
                    $('#ad_storage').click();
                }
                if (consents.includes('analytics_storage')) {
                    $('#analytics_storage').click();
                }
                /*if (consents.includes('functionality_storage')) {
                    $('#functionality_storage').click();
                }*/

            }
        }
    },
    createAndShowContainer: function () {
        const doit = function (container, content){
            CookieApprove.container = $(container);
            CookieApprove.containerSettings = $(content);
            CookieApprove.container.add(CookieApprove.containerSettings).find('.approveAll').click(function (e) {
                e.preventDefault();
                CookieApprove.Approve();
            });
            CookieApprove.container.find('.showSettings').click(function (e) {
                e.preventDefault();
                CookieApprove.containerSettings.show(0);
            });

            CookieApprove.containerSettings.find('.CookieClose').click(function (e) {
                e.preventDefault();
                CookieApprove.containerSettings.slideUp("slow", function () {
                    CookieApprove.containerSettings.remove();
                });
                CookieApprove.container.slideUp("slow", function () {
                    CookieApprove.container.remove();
                });
            });

            CookieApprove.containerSettings.find('input').each(function () {

                $(this).change(function () {
                    $(this).parent().toggleClass('checked');
                });
            });
            CookieApprove.containerSettings.find('.saveSelected ').click(function (e) {
                e.preventDefault();
                const consets = [];
                $(".CookieApproveSettings input:checked").each(function (input) {
                    consets.push($(this).val());
                });
                gtag('consent', 'update', {
                    'ad_storage' : consets.includes('ad_storage') ? 'granted' :  'denied',
                    'ad_user_data' : consets.includes('ad_storage') ? 'granted' :  'denied',
                    'ad_personalization' : consets.includes('ad_storage') ? 'granted' :  'denied',
                    'analytics_storage' : consets.includes('analytics_storage') ? 'granted' :  'denied',
                    //'functionality_storage' : consets.includes('functionality_storage') ? 'granted' :  'denied',
                    //'personalization_storage' : consets.includes('personalization_storage') ? 'granted' :  'denied',
                });
                gtag('event', 'cookie_consent_update');
                CookieApprove.setCookie(consets.join(","));
                CookieApprove.containerSettings.slideUp("slow", function () {
                    CookieApprove.containerSettings.remove();
                });
                CookieApprove.container.slideUp("slow", function () {
                    CookieApprove.container.remove();
                });
            });
            /*$body.append(CookieApprove.container);
            $body.append(CookieApprove.containerSettings);

            CookieApprove.container.show(0);*/
        };
        doit($('#CookieApprove'), $('#CookieApproveSettings'));
        CookieApprove.checkSettings();
        /*$.ajax({
            url: ABSOLUTE_URL + 'plugins/cookie-approve/ajax.php',
            method: "POST",
            data: { func: "get_cookie_approve"},
            dataType: 'json',
            success: function (data) {
                doit(data.container, data.content);
                CookieApprove.checkSettings();
            }
        });*/
    },
    setCookie: function (value) {
        const days = 30;
        const exdate = new Date();
        exdate.setTime(exdate.getTime() + ((days * 24 * 3600) * 1000));
        const c_value = value + "; expires=" + exdate.toUTCString() + ";path=/";
        document.cookie = c_name + "=" + c_value;
    }
}

CookieApprove.Start();